import { render, staticRenderFns } from "./BusinessGuideQuickTour.vue?vue&type=template&id=d28c7790"
import script from "./BusinessGuideQuickTour.vue?vue&type=script&lang=js"
export * from "./BusinessGuideQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports